<script lang="ts">
  import type { GroupedTransaction } from "../../../../api/transactions";
  import { valueWithCurrency } from "../../../../helpers/utils";
  import ToggleButton from "../../../buttons/ToggleButton.svelte";
  import DatePanelHeader from "../DatePanelHeader.svelte";
  import PdfDocumentView from "../PDFDocumentView.svelte";

  const TITLE_TYPE_MAP: Record<string, string> = {
    invoice_arrived: "invoice",
    manual_invoice: "invoice",
    payment: "invoice",
    pro_invoice_arrived: "invoice",
    refund: "credit note",
    creditnote: "credit note",
  };

  export let transaction: GroupedTransaction;
  export let selected: boolean = false;
  export let didSelect: (transaction?: GroupedTransaction) => void;

  let zoomed: boolean = false;

  function onToggle() {
    if (selected) {
      didSelect(undefined);
    } else {
      didSelect(transaction);
    }
  }

  $: title = `${TITLE_TYPE_MAP[transaction.type]} - ${
    transaction.line_item_count
  } items, ${valueWithCurrency(transaction.amount_cents / 100, "GBP")}`;

  $: subtitle = transaction.confirmed_by && `confirmed by ${transaction.confirmed_by}`;

  $: invoiceDate = new Date(transaction.invoice_date || new Date());
</script>

<div class="container">
  <div class="header">
    <DatePanelHeader date={invoiceDate} {title} {subtitle} />
    <ToggleButton size={56} {onToggle} active={selected} />
  </div>

  <div class="invoice-image" class:zoom={zoomed}>
    <PdfDocumentView
      url={transaction.document_url}
      bind:zoomed
      showGradient={false}
      condensed={true}
    />
  </div>
</div>

<style>
  .container {
    background-color: var(--rekki-light);
    padding: 16px 16px 0 16px;
    width: 100%;
  }

  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .invoice-image {
    position: relative;
    justify-content: center;
    width: 100%;
    height: 548px;
    overflow: hidden;
    background-color: var(--rk-neutral-0);
    border: solid 1px var(--rk-divider-0);
    border-radius: 8px;
    margin-top: 16px;
    margin-bottom: 8px;
    transition: all 0.3s ease-in-out;
  }

  .zoom {
    height: 686px;
  }
</style>
